var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8571 23.3333V11.6667H8.19048V23.3333H15.8571ZM15.8571 7C16.4381 7 16.9952 7.24583 17.406 7.68342C17.8168 8.121 18.0476 8.71449 18.0476 9.33333V25.6667C18.0476 26.2855 17.8168 26.879 17.406 27.3166C16.9952 27.7542 16.4381 28 15.8571 28H8.19048C6.97476 28 6 26.95 6 25.6667V9.33333C6 8.71449 6.23078 8.121 6.64158 7.68342C7.05237 7.24583 7.60953 7 8.19048 7H15.8571ZM21.881 7H27.3571C27.7929 7 28.2107 7.18437 28.5188 7.51256C28.8269 7.84075 29 8.28587 29 8.75V12.25C29 12.7141 28.8269 13.1592 28.5188 13.4874C28.2107 13.8156 27.7929 14 27.3571 14H23.5238L20.2381 17.5V14V8.75C20.2381 8.28587 20.4112 7.84075 20.7193 7.51256C21.0274 7.18437 21.4452 7 21.881 7Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgR);
export default __webpack_public_path__ + "static/media/MsgR.124473905f72ca7c0f76377ec98a06df.svg";
export { ForwardRef as ReactComponent };